import React, { useEffect } from 'react'
import { Modal, Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { translate } from 'react-i18next'
import { isEmpty } from 'lodash'
import { HIDE_POPUP } from '../redux/actions/type'

const PopupInfo = ({ t }) => {
    const popup = useSelector(state => state.popup)
    const dispatch = useDispatch()
    const {
        isShow,
        textHeader,
        textBody,
        textButton,
        action
    } = popup
    const onAction = () => {
        if (isEmpty(action)) {
            dispatch({
                type: HIDE_POPUP,
                payload: {
                    isShow: false
                }
            })
        } else {
            window.location.href = action
        }
    }
    useEffect(() => {

    }, [popup])
    return (
        <>
            <Modal
                title={textHeader !== '' ? t(textHeader) : t("popupInfo.header")}
                visible={isShow}
                className="modalInfo"
                closable={false}
                width={388}
                footer={<div>
                    <Button onClick={onAction.bind(this)}>{textButton !== '' ? t(textButton) : t("popupInfo.button")}</Button>
                </div>}
            >
                <label>{t(textBody)}</label>
            </Modal>
        </>
    )
}

export default translate()(PopupInfo)